import {h, Component} from 'preact';
import cx from 'classnames'
import { Inquiry } from 'types/inquiries';

interface InquiryClientInfoProps {
  centered?: boolean;
  inquiry: Inquiry;

  forCardMode?: boolean;
  forceDefaultStyling?: boolean;
}

export class InquiryClientInfo extends Component<InquiryClientInfoProps> {

  getDesignationString(designationCode: number) {
    switch (designationCode) {
      case 1:
        return 'Buyer/Renter';
      case 2:
        return 'Broker/Agent'
      default:
        return 'Other';
    }
  }

  render() {
    const { centered, inquiry } = this.props;

    return (
      <div className={ cx("hi-inqcard__cell hi-inqcard__name-group", {
        'text-center': centered,
        'hi-inqcard--for-collection': inquiry.stage === 'For Collection' && !this.props.forceDefaultStyling
      }) }>

        <strong className="hi-inqcard__inqcode">{ inquiry.inquiryCode }</strong>
        <span className="hi-inqcard__inqname">{ inquiry.client.name }</span>
        <span className="hi-inqcard__designation">
          { this.getDesignationString(inquiry.client.designation) }
        </span>
      </div>
    )
  }
}
